var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    { attrs: { id: "inspire" } },
    [
      _c(
        "v-snackbar",
        {
          attrs: { color: _vm.logoffFailure ? "red" : "success" },
          model: {
            value: _vm.logoffSnackbar,
            callback: function ($$v) {
              _vm.logoffSnackbar = $$v
            },
            expression: "logoffSnackbar",
          },
        },
        [_vm._v(" " + _vm._s(_vm.logoffMessage))]
      ),
      _c(
        "v-main",
        [
          _c(
            "v-container",
            { staticClass: "fill-height", attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                { attrs: { align: "center", justify: "center" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "8", md: "4" } },
                    [
                      _c(
                        "v-card",
                        { staticClass: "elevation-12 rounded-b-0" },
                        [
                          _c(
                            "v-toolbar",
                            { attrs: { color: "primary", dark: "", flat: "" } },
                            [
                              _c(
                                "v-toolbar-title",
                                { attrs: { id: "login_form_title" } },
                                [_vm._v(" Login to Heimdall Server ")]
                              ),
                              _c("v-spacer"),
                            ],
                            1
                          ),
                          _c(
                            "v-tabs",
                            {
                              attrs: {
                                active: "",
                                value: _vm.activeTab,
                                "background-color": "primary darken-1",
                                color: "primary-visible",
                                "show-arrows": "",
                              },
                            },
                            [
                              _vm.anyAuthProvidersAvailable
                                ? _c(
                                    "v-tab",
                                    {
                                      attrs: {
                                        id: "select-tab-standard-login",
                                        href: "#login-standard",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Heimdall Login (Local Authorization)"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.ldapenabled
                                ? _c(
                                    "v-tab",
                                    {
                                      attrs: {
                                        id: "select-tab-ldap-login",
                                        href: "#login-ldap",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "Organization Login (LDAP Authorization)"
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _c(
                                "v-tab-item",
                                { attrs: { value: "login-standard" } },
                                [_c("LocalLogin")],
                                1
                              ),
                              _c(
                                "v-tab-item",
                                { attrs: { value: "login-ldap" } },
                                [_c("LDAPLogin")],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }